export const EN = {
  shared: {
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    ok: 'Ok',
    save: 'Save',
    saveChanges: 'Save Modifications?',
    confirm: 'Confirm?',
    goBack: 'Go back',
    search: 'Search',
    all: 'All',
    minimum: 'min',
    maximum: 'max',
    logout: 'Disconnect',
    preview: 'Preview',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    date: 'Date',
    send: 'Send',
    from: 'From',
    to: 'To',
    delete: 'Delete',
    filters: 'Filters',
    clearFilters: 'Clear Filters',
    download: 'Download',
  },
  home: {
    subtitle: 'Thematic word-guessing game',
    trending: 'Trending Themes',
    create: 'Create your theme',
    showMoreThemes: 'Show More Themes',
    filter: 'Filter',
  },
  grid: {
    wordFound: 'Word found!!',
    theme: 'Theme:',
    words: 'words',
    noTheme: 'Please select a theme',
    wordUnknown: 'Word not in dictionary',
    congratulations: '🎉 Congratulations 🎉',
    finished: 'You found all the words of an entire theme!! Try another one below',
    tooBad: '😭 You lost 😭',
    gameLost: 'You have to retry from the beginning... The word was: ',
  },
  wheel: {
    congratulations: '🎉 Congratulations 🎉',
    history: 'History',
    gameLost: 'You have to retry from the beginning... The word was: ',
    explanation:
      'Hangman word-guessing game. You are tasked with guessing a hidden word letter by letter before the wheel is empty.',
  },
  melo: {
    explanation: 'Wordsearch puzzle. You are tasked with finding words in a grid, letter by letter.',
    pickLine: 'Pick a line and type letters',
    letters: 'Find 2 words from this letters',
  },
  addTheme: {
    title: `Here you can add a new theme. The most important part is the list of words which you want to add.
      The more words, the better!`,
    email: 'Email',
    emailExplained:
      'This email will not be shared with anyone. It will be used only to contact you in case of problems.',
    name: 'Name',
    lang: 'Language',
    noLang: 'World (for no specific language)',
    all: 'All',
    nameExplained: 'It will be used as the title, choose wisely',
    words: 'Words, 1 per line OR comma separated. (minimum 10)',
    save: 'Save',
    comments: 'Comments',
    commentsExplained: 'You can add some explanation about the theme.',
    tooFewWords: 'The theme must have at least 10 words',
    success: 'Congratulations 🎉 You have created a new theme. You can access it here:',
    success2: 'or share the URL',
    shareMail: 'This is my list of words. You can try it now: ',
  },
  errors: {
    BadParameters: {
      title: 'Bad parameters sent',
    },
    ApiOff: {
      title: 'Server unreachable',
      message: 'The server is unreachable. Please, check your internet connection or retry in a moment.',
    },
    Unauthorized: {
      title: 'Unauthorized',
      message: 'You are not logged in!',
    },
    Notfound: {
      title: 'Item not found',
      message: "We can't find what you are looking for.",
    },
    UserNotFound: {
      title: 'User not found',
      message: 'User is not allowed to connect here. Please, contact an administrator.',
    },
    ServerError: {
      title: 'Server Error',
      message: 'The server encountered an error. Please contact the technical service.',
    },
    ClientError: {
      title: 'Client Error',
      message: '',
    },
    BadGateway: {
      title: 'Gateway Error',
      message: '',
    },
    ServiceUnavailable: {
      title: 'Maintenance',
      message: '',
    },
    Timeout: {
      title: 'Timeout',
      message: 'The server took too long to respond. Please, retry in a moment.',
    },
  },
};
